import firebase from "../../config/firebase";

export const addManagersRequests =
  (data, onSuccess = () => {}) =>
  async (dispatch) => {
    try {
      let docRef = await firebase
        .firestore()
        .collection("request_manager_teach")
        .add(data);
      const newRequest = { id: docRef.id, ...data };

      dispatch({
        type: "ADD_REQUEST",
        payload: newRequest,
      });

      onSuccess("success");
    } catch (error) {
      onSuccess();
      console.error("Error adding document: ", error);
    }
  };

export const fetchManagersRequests =
  (id, lastDoc, onSuccess = () => {}) =>
  async (dispatch) => {
    try {
      let query = firebase
        .firestore()
        .collection("request_manager_teach")
        .where("requestedId", "==", id)
        .limit(5);
      if (lastDoc) {
        query = query.startAfter(lastDoc);
      }
      await query.get().then(async (quary) => {
        let data = [];
        for await (let doc of quary.docs) {
          data.push({ id: doc.id, ...doc.data() });
        }
        const lastVisible = quary.docs[quary.docs.length - 1];
        const hasMore = data.length === 5;
        dispatch({
          type: lastDoc
            ? "FETCH_MANAGER_REQUESTS_LOAD_MORE"
            : "FETCH_REQUEST_MANAGER",
          payload: { data, lastVisible, hasMore },
        });
        onSuccess();
      });
    } catch (error) {
      console.error("Error fetching documents: ", error);
      onSuccess();
    }
  };

export const deleteRequest =
  (id, onSuccess = () => {}) =>
  async (dispatch) => {
    try {
      await firebase
        .firestore()
        .collection("request_manager_teach")
        .doc(id)
        .delete();

      dispatch({
        type: "DELETE_REQUEST",
        payload: id,
      });

      onSuccess();
    } catch (error) {
      console.error("Error deleting document: ", error);
    }
  };

export const editRequest =
  (id, updatedData, onSuccess = () => {}) =>
  async (dispatch) => {
    try {
      await firebase
        .firestore()
        .collection("request_manager_teach")
        .doc(id)
        .update(updatedData);

      dispatch({
        type: "EDIT_REQUEST",
        payload: { id, ...updatedData },
      });

      onSuccess("success");
    } catch (error) {
      console.error("Error updating document: ", error);
    }
  };

export const getManagerHelpRequests =
  (lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    try {
      const limit = 5;
      let query = firebase
        .firestore()
        .collection("request_manager_teach")
        .where("type", "==", "manager")
        .limit(limit);

      if (lastDocument) {
        query = query.startAfter(lastDocument);
      }

      const snapshot = await query.get();
      const data = [];

      for (const doc of snapshot.docs) {
        const schoolDoc = await firebase
          .firestore()
          .collection("users")
          .doc(doc.data().requestedId)
          .get();
        data.push({ id: doc.id, ...doc.data(), school: schoolDoc.data() });
      }

      const hasMore = snapshot.docs.length === limit;
      const newLastDocument = snapshot.docs[snapshot.docs.length - 1];

      dispatch({
        type: lastDocument
          ? "GET_MANAGER_HELP_REQUESTS_MORE"
          : "GET_MANAGER_HELP_REQUESTS",
        payload: { requests: data, lastDocument: newLastDocument, hasMore },
      });

      onComplete(newLastDocument, hasMore);
    } catch (error) {
      console.error("Error loading manager help requests:", error);
      onComplete(null, false);
    }
  };
